import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Switch,
  Button,
} from "antd";
import { Link } from "react-router-dom";
import api from "utils/api";

const { Title } = Typography;

const PayoutSettingUser = () => {
  const [all_permission, setAllPermission] = useState();
  const [dashboard, setDashboard] = useState();
  const [paymentLink, setPaymentLink] = useState();
  const [transaction, setTransaction] = useState();
  const [bill_payment, setBillPayment] = useState();
  const [money_transfer, setMoneyTransfer] = useState();
  const [recharge, setRecharge] = useState();
  const [vender_payment, setVenderPayment] = useState();
  const [complaint_management, setComplaintManagement] = useState();
  const [gift_voucher, setGiftVoucher] = useState();
  const [isTableLoading, setIsTableLoading] = useState(false);

  const segment = window.location.pathname.split("/");
  const partnerId = segment[2];

  useEffect(() => {
    fetchManagerList();
  }, []);

  const fetchManagerList = async () => {
    setIsTableLoading(true);
    try {
      const response = await api.post(
        "https://billpay.mtmpay.in/Admin/api/admin/merchant-permission-data",
        {
          user_id: partnerId,
        }
      );
      const obj = response.data.data;
      setAllPermission(obj.all_permission);
      setDashboard(obj.dashboard);
      setPaymentLink(obj.users);
      setTransaction(obj.transaction);
      setBillPayment(obj.bill_payment);
      setMoneyTransfer(obj.money_trasfer);
      setRecharge(obj.recharge);
      setVenderPayment(obj.vender_payment)
      setComplaintManagement(obj.complain_managment);
      setGiftVoucher(obj.gift_voucher);
    } catch (error) {
      console.error("Error fetching manager list:", error);
    }
    setIsTableLoading(false);
  };

  const handleMerchantToggle = async (checked, type) => {
    let permissionType;
    switch (type) {
      case "payin_all_permission":
        permissionType = "payin_all_permission";
        break;
      case "1":
        permissionType = "dashboard";
        break;
      case "2":
        permissionType = "transaction";
        break;
      case "3":
        permissionType = "bill_payment";
        break;
      case "4":
        permissionType = "money_trasfer";
        break;
      case "5":
        permissionType = "recharge";
        break;
      case "6":
        permissionType = "complain_managment";
        break;
           case "7":
        permissionType = "vender_payment";
        break;
           case "8":
        permissionType = "gift_voucher";
        break;
      default:
        return;
    }

    try {
      await api.post(
        "https://billpay.mtmpay.in/Admin/api/admin/admin-merchant-permission-set",
        {
          all_permission: checked.toString(),
          type: permissionType,
          status: checked.toString(),
          user_id: partnerId,
        }
      );
      fetchManagerList();
    } catch (error) {
      console.error("Error updating permission:", error);
    }
  };

  return (
    <div className="wallet partner-user-setting">
      <div className="overviewBorder">
        <Row justify="space-between" align="middle">
          <Card className="small_card">
            <div className="d-flex align-items-center">
              <Title level={3} className="mb-0 mr-8 main-title">
                All Permission
              </Title>
              <Switch
                checked={all_permission === "true"}
                onChange={(checked) =>
                  handleMerchantToggle(checked, "payin_all_permission")
                }
              />
            </div>
          </Card>

          <Card className="small_card">
            <Link to="/roles-permission">
              <Button type="primary" size="large">
                <span style={{ marginRight: "7px", fontSize: "18px" }}>
                  &larr;
                </span>
                Back
              </Button>
            </Link>
          </Card>
        </Row>
      </div>

      <div className="ant-modal-content">
        <Row>
          <Col xs={24} sm={24} md={12} lg={12} style={{ padding: "15px" }} className="border-radiussec display bg1">
            <Title level={3} className="mb-0">Dashboard</Title>
            <Switch
              checked={dashboard === "true"}
              onChange={(checked) => handleMerchantToggle(checked, "1")}
            />
          </Col>

          <Col xs={24} sm={24} md={12} lg={12} style={{ padding: "15px" }} className="border-radiusthird display bg3">
            <Title level={3} className="mb-0">Transaction</Title>
            <Switch
              checked={transaction === "true"}
              onChange={(checked) => handleMerchantToggle(checked, "2")}
            />
          </Col>
        </Row>
      </div>

      <div className="ant-modal-content">
        <Row>
          <Col xs={24} sm={24} md={12} lg={12} style={{ padding: "15px" }} className="border-radiussec bg4">
            <Row>
              <Col xs={20}>
                <Title level={3}>Bill Payment</Title>
              </Col>
              <Col xs={4}>
                <Switch
                  checked={bill_payment === "true"}
                  onChange={(checked) => handleMerchantToggle(checked, "3")}
                />
              </Col>
            </Row>
          </Col>

          <Col xs={24} sm={24} md={12} lg={12} style={{ padding: "15px" }} className="border-radiusthird display bg3">
            <Title level={3} className="mb-0">Money Transfer</Title>
            <Switch
              checked={money_transfer === "true"}
              onChange={(checked) => handleMerchantToggle(checked, "4")}
            />
          </Col>
        </Row>
      </div>

      <div className="ant-modal-content">
        <Row>
          <Col xs={24} sm={24} md={12} lg={12} style={{ padding: "15px" }} className="border-radiussec bg4">
            <Row>
              <Col xs={20}>
                <Title level={3}>Recharge</Title>
              </Col>
              <Col xs={4}>
                <Switch
                  checked={recharge === "true"}
                  onChange={(checked) => handleMerchantToggle(checked, "5")}
                />
              </Col>
            </Row>
          </Col>

          <Col xs={24} sm={24} md={12} lg={12} style={{ padding: "20px" }} className="border-radiusthird display bg2">
            <Title level={3}>Complaint Management</Title>
            <Switch
              checked={complaint_management === "true"}
              onChange={(checked) => handleMerchantToggle(checked, "6")}
            />
          </Col>
        </Row>
      </div>
        <div className="ant-modal-content">
        <Row>
          <Col xs={24} sm={24} md={12} lg={12} style={{ padding: "20px" }} className="border-radiussec display bg1">
            <Title level={3}>Vender Payment</Title>
            <Switch
              checked={vender_payment === "true"}
              onChange={(checked) => handleMerchantToggle(checked, "7")}
            />
          </Col>

     <Col xs={24} sm={24} md={12} lg={12} style={{ padding: "20px" }} className="border-radiusthird display giftbg">
            <Title level={3}>Gift Voucher</Title>
            <Switch
              checked={gift_voucher === "true"}
              onChange={(checked) => handleMerchantToggle(checked, "8")}
            />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default PayoutSettingUser;
